import axios from "./axios";

function findByID(id) {
    return axios().get(`/requisitions/${id}`);
}

function create(data) {
    return axios().post("/requisitions", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    });
}

function update(data) {
    return axios().put(`/requisitions/${data.id}`, data);
}
function remove(data) {
    return axios().delete(`/requisitions/${data.id}`)
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.limit;
    return axios().get("/requisitions", {
        params
    })
}

function close(data) {
    return axios().put(`/requisitions/${data.id}/close`);
}

function getStates() {
    return axios().get(`/requisitions-states`);
}

export default {
    findByID,
    create,
    update,
    remove,
    index,
    close,
    getStates
}